import React from 'react';
import TabTicketByParams from '../Tabs/TabTicketByParams';
import TicketFilterV2 from './Filter';
import styled from 'styled-components';

const VoidedTickets = () => {
  return (
    <Container>
      <TicketFilterV2 type='VOID' />
      <div className="tickets">
        <TabTicketByParams v2 tableKey={'VOID'} />
      </div>
    </Container>
  );
};

export default VoidedTickets;

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .tickets {
    flex: 1;
    position: relative;
  }
`;